import React from 'react';
import { StyledBrandLogo, StyledContainer, styles } from './BrandsMarqueeItem.styles';
import { SkeletonGroup, SkeletonThumbnail } from '@shared/components/Skeleton';

interface BrandsMarqueeItemProps {
  imageUrl: string;
  onClick?: () => void;
  showSkeleton?: boolean;
}

export const BrandsMarqueeItem: React.FC<BrandsMarqueeItemProps> = props => {
  const { imageUrl, onClick, showSkeleton } = props;
  return (
    <SkeletonGroup placeholder={<SkeletonThumbnail {...styles.itemHeight} width={'200px'} marginX={'40px'} />} isReady={!showSkeleton}>
      <StyledContainer onClick={onClick} cursor={onClick ? 'pointer' : 'auto'} __css={styles.itemHeight} {...styles.container}>
        <StyledBrandLogo src={imageUrl} />
      </StyledContainer>
    </SkeletonGroup>
  );
};
